import { theme } from "@theme";
import { Stack } from "expo-router";
import { ensureStackAnchorListeners } from "@utils/navigation/ensureStackAnchor";

export const unstable_settings = {
  initialRouteName: "index",
};

export default function ExclusivesStack() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: theme.colors.screenBg },
      }}
      screenListeners={ensureStackAnchorListeners("index")}
    >
      <Stack.Screen name="index" />
    </Stack>
  );
}
